<template>
  <div
    class="container"
    @click="$emit('click')"
  >
    <span class="scroll-btn">
      <SvgAsset
        :content="scrollArrowPath"
        class="scroll-btn__icon"
      />
    </span>
  </div>
</template>

<script>
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import scrollArrowPath from '@/assets/images/svg/scroll-arrow.svg?raw';

  export default {
    name: 'ScrollButton',
    components: { SvgAsset },
    emits: ['click'],
    computed: {
      scrollArrowPath: () => scrollArrowPath,
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding: 18px;
    height: 100%;
    cursor: pointer;

    @include hover {
      .scroll-btn {
        background-color: #000000;
      }

      .scroll-btn__icon {
        color: #fff;
      }
    }
  }

  .scroll-btn {
    background: #ffffff;
    border-radius: 16px;
    border: 2px solid $border-color--1;
    width: 40px;
    height: 40px;
    box-shadow: 0 4px 8px rgb(0 0 0 / 20%);
    display: flex;
    align-items: center;

    &__icon {
      color: #000;
      min-width: 12px;
      height: 19px;
      margin-left: 14.26px;
      margin-right: 10.34px;
    }
  }
</style>
